module.exports = __webpack_public_path__ + "img/Rectangle.4906d975.png";